import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RentalPartnerDetailScreen from './screens/RentalPartnerDetailScreen';
import RentalPartnerListScreen from './screens/RentalPartnerListScreen';

function RentalPartners() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RentalPartnerListScreen />} />
          <Route path=":rentalPartnerId" element={<RentalPartnerDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RentalPartners;
